// extracted by mini-css-extract-plugin
export default {"container":"newComponentConfigurator_container__OyjWv","container__configurator":"newComponentConfigurator_container__configurator__vxoA0"};